var exports = {
  "CT": "DiscoverySkeleton.module__navList___dGdXMT",
  "pc": "DiscoverySkeleton.module__navItem___dGdXMT",
  "HW": "DiscoverySkeleton.module__navItemActive___dGdXMT",
  "hk": "DiscoverySkeleton.module__navItemLabel___dGdXMT",
  "kL": "DiscoverySkeleton.module__container___dGdXMT",
  "v_": "DiscoverySkeleton.module__navbar___dGdXMT",
  "$L": "DiscoverySkeleton.module__categoryTabs___dGdXMT",
  "VJ": "DiscoverySkeleton.module__navbarSearch___dGdXMT",
  "Gm": "DiscoverySkeleton.module__scrollBody___dGdXMT",
  "Qs": "DiscoverySkeleton.module__content___dGdXMT",
  "Vg": "DiscoverySkeleton.module__grid___dGdXMT",
  "Nr": "DiscoverySkeleton.module__card___dGdXMT",
  "zl": "DiscoverySkeleton.module__cardBanner___dGdXMT",
  "Ie": "DiscoverySkeleton.module__cardIcon___dGdXMT",
  "zI": "DiscoverySkeleton.module__cardBody___dGdXMT",
  "JJ": "DiscoverySkeleton.module__cardTitle___dGdXMT",
  "L_": "DiscoverySkeleton.module__cardDescription___dGdXMT",
  "UX": "DiscoverySkeleton.module__cardFooter___dGdXMT",
  "Kd": "DiscoverySkeleton.module__cardStats___dGdXMT",
  "Ne": "DiscoverySkeleton.module__cardStat___dGdXMT",
};

module.exports = exports;
